// import { Theme } from '@mui/material';
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
// import makeStyles from '@mui/styles/makeStyles';
import { logError } from "helpers/rxjs-operators/logError";
import React, { forwardRef, memo } from "react";
import { useObservable } from "react-use-observable";
import loaderService from "services/loader";

// const useStyle = makeStyles((theme: Theme) => ({
//   loader: {
//     width: 70,
//     height: 70,
//     color: theme.palette.secondary.light
//   },
//   paper: {
//     boxShadow: 'none',
//     outline: 'none',
//     backgroundColor: 'transparent'
//   }
// }));

const Loader = memo((props: {}) => {
  // const classes = useStyle(props);
  const [visible] = useObservable(
    () => loaderService.shouldShow().pipe(logError()),
    []
  );

  // const paperProps = useMemo(() => ({ className: classes.paper }), [classes.paper]);

  return (
    <Dialog open={visible || false} TransitionComponent={Transition}>
      <CircularProgress size="large" color="inherit" />
    </Dialog>
  );
});

const Transition = memo(
  forwardRef((props: any, ref: any) => {
    return <Slide direction="up" {...props} ref={ref} />;
  })
);

export default Loader;
